import {
  Modal,
  ModalActions,
  ModalContent,
  ModalTitle,
} from '@cambridgeassessment/cambridge-ui';
import { Box, Button, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader/root';
import { Prompt, useHistory, useLocation } from 'react-router-dom';
import useOrgUserDetails from 'src/hooks/useOrgUserDetails';
import { useModalStyles } from './styles';

type Props = {
  when: boolean;
  onConfirm: () => void;
  onReject: () => void;
};

const NavConfirmation: React.FC<Props> = ({ when, onConfirm, onReject }) => {
  const location = useLocation();
  const history = useHistory();
  const { userDetails } = useOrgUserDetails();
  const [open, setOpen] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [next, setNext] = useState(null);

  const handleLocationBlock = (nextLocation) => {
    if (nextLocation.pathname !== location.pathname) {
      setNext(nextLocation.pathname);
      setOpen(true);
      return false;
    }
    return true;
  };

  const closeModal = () => {
    setOpen(false);
  };

  const handleNoSave = () => {
    onReject();
    closeModal();
    setConfirmed(true);
  };

  const handleSave = () => {
    closeModal();
    onConfirm();
    setConfirmed(true);
  };

  useEffect(() => {
    if (confirmed && next) {
      history.push(next);
    }
  }, [confirmed, next]);

  const classes = useModalStyles();

  return (
    <>
      <Prompt when={when} message={handleLocationBlock} />

      <Modal
        open={open}
        size="small"
        onClose={closeModal}
        data-testid="nav-confirmation-modal"
      >
        <Box className={classes.modalTitle}>
          <ModalTitle
            onClose={closeModal}
            data-testid="nav-confirmation-header"
          >
            {`Save changes to ${userDetails.firstName} ${userDetails.lastName}?`}
          </ModalTitle>
        </Box>
        <ModalContent data-testid="nav-confirmation-body">
          <Typography variant="body1" className={classes.modalText}>
            Do you want to save your changes before you leave this page? If you
            don’t save, your changes will be lost.
          </Typography>
        </ModalContent>
        <ModalActions>
          <Button
            onClick={handleNoSave}
            color="primary"
            variant="outlined"
            className={classes.dontSaveButton}
            data-testid="nav-cancel-confirmation-modal"
          >
            Don&apos;t save
          </Button>
          <Box className={classes.saveButton}>
            <Button
              onClick={handleSave}
              color="primary"
              data-testid="nav-confirm-confirmation-modal"
            >
              Save changes
            </Button>
          </Box>
        </ModalActions>
      </Modal>
    </>
  );
};

export default hot(NavConfirmation);
